import { useState, useCallback } from 'react';

/**
 * Custom hook to manage modal state
 *
 * @param {any} initialData - Initial data for the modal (default: null)
 *
 * @returns {object} Modal state and handlers
 */
export const useModalState = (initialData = null) => {
  const [isOpen, setIsOpen] = useState(false);
  const [data, setData] = useState(initialData);

  const open = useCallback((modalData = null) => {
    setData(modalData);
    setIsOpen(true);
  }, []);

  const close = useCallback(() => {
    setIsOpen(false);
    // Delay clearing data to allow exit animations
    setTimeout(() => setData(initialData), 300);
  }, [initialData]);

  const toggle = useCallback(() => {
    setIsOpen(prev => !prev);
  }, []);

  return {
    isOpen,
    data,
    open,
    close,
    toggle,
    setData,
  };
};

export default useModalState;
